<template>
    <div>
        <template v-if="region == true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Region </h1>
                <router-link to="/addRegion" class="btn btn-primary active float-right" v-if="crud_region === true"> Add Region</router-link>
            </div>
            <div class="table">
                <table id="regionsTable" class="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Created</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                </table>
            </div>
        </template>
        <template v-else-if="region === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="region === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                crud_region : false,
                region : null
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_region|region').then(result => {
                this.crud_region = result.crud_region;
                this.region = result.region;
            }).then(result => {
                if(this.region == true){
                    this.listRegions();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            listRegions: function(){
                var that = this;
                $('#regionsTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listRegions",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id'},
                        {data: 'name'},
                        {data: 'created_at'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editRegion/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                        }, visible: that.crud_region},
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 3 ]
                    }],
                });
            }
        },
        created() {
        }
    }
</script>
